import { render, staticRenderFns } from "./GroupPOIsMenu.vue?vue&type=template&id=21fca94a&scoped=true&"
import script from "./GroupPOIsMenu.vue?vue&type=script&lang=js&"
export * from "./GroupPOIsMenu.vue?vue&type=script&lang=js&"
import style0 from "./GroupPOIsMenu.vue?vue&type=style&index=0&id=21fca94a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21fca94a",
  null
  
)

export default component.exports